"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewCartButton = void 0;
const React = require("react");
const styles = require("./StripeCartOverview.styles.scss");
const StripePaymentOptions_1 = require("../StripePaymentOptions/StripePaymentOptions");
const ReviewCartItems_1 = require("./ReviewCartItems");
const FlatButton_1 = require("../BasicComponents/FlatButton");
const md_1 = require("react-icons/md");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../structure/Modal");
exports.default = () => {
    return (React.createElement("div", { className: styles.overviewContainer },
        React.createElement(MobileCartOptions, null),
        React.createElement("div", { style: { flex: 1 } },
            React.createElement(StripePaymentOptions_1.default, null)),
        React.createElement("div", { style: { flex: 2 } })));
};
const MobileCartOptions = () => {
    const [showCart, setShowCart] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(exports.ViewCartButton, { onClick: () => setShowCart(true) }),
        React.createElement(Modal_1.Modal, { open: showCart, onClose: () => setShowCart(false), size: dialogs_1.TDialogSizes.Large, appMode: true },
            React.createElement(Modal_1.ModalHeader, null, "View Cart"),
            React.createElement(Modal_1.ModalBody, null,
                React.createElement(ReviewCartItems_1.default, null)))));
};
const ViewCartButton = ({ onClick }) => {
    return (React.createElement(FlatButton_1.default, { onClick: onClick, style: {
            margin: 20,
            background: "white",
            border: "solid 2px #D5ECDD",
            color: "#63A555",
            display: "flex",
            justifyContent: "center"
        } },
        React.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginRight: 10
            } },
            React.createElement(md_1.MdOutlineShoppingCart, null)),
        React.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            } }, "VIEW CART")));
};
exports.ViewCartButton = ViewCartButton;
//# sourceMappingURL=StripeCartOverview.js.map